/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';

import Vue from 'vue';


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

//Consent components
Vue.component('consent-root-component', require('./components/ConsentRootComponent.vue').default);

//Home component
Vue.component('home-root-component', require('./components/HomeRootComponent.vue').default);

//Dashboard menu
Vue.component('dashboard-menu-component', require('./components/DashboardMenuComponent.vue').default);

//Resource components
Vue.component('resource-root-component', require('./components/ResourceRootComponent.vue').default);
Vue.component('resource-list-component', require('./components/ResourceListComponent.vue').default);
Vue.component('resource-form-component', require('./components/ResourceFormComponent.vue').default);
Vue.component('resource-summary-component', require('./components/ResourceSummaryComponent.vue').default);
Vue.component('multi-resource-summary-component', require('./components/MultiResourceSummaryComponent.vue').default);
Vue.component('resource-map-component', require('./components/ResourceMapComponent.vue').default);
Vue.component('resource-data-component', require('./components/ResourceDataComponent.vue').default);
Vue.component('resource-publish-component', require('./components/ResourcePublishComponent.vue').default);
Vue.component('irr-list-component', require('./components/IrrListComponent.vue').default);

//IRR components
Vue.component('irr-root-component', require('./components/IrrRootComponent.vue').default);
Vue.component('irr-request-root-component', require('./components/IrrRequestRootComponent.vue').default);
Vue.component('irr-resource-map-component', require('./components/IrrResourceMapComponent.vue').default);
Vue.component('irr-summary-component', require('./components/IrrSummaryComponent.vue').default);
Vue.component('multi-irr-summary-component', require('./components/MultiIrrSummaryComponent.vue').default);
Vue.component('irr-full-list-component', require('./components/IrrFullListComponent.vue').default);
Vue.component('irr-form-component', require('./components/IrrFormComponent.vue').default);
Vue.component('irr-request-form-component', require('./components/IrrRequestFormComponent.vue').default);
Vue.component('irr-request-list-component', require('./components/IrrRequestListComponent.vue').default);
Vue.component('irr-request-data-component', require('./components/IrrRequestDataComponent.vue').default);
Vue.component('irr-access-request-data-component', require('./components/IrrAccessRequestDataComponent.vue').default);
Vue.component('irr-access-request-list-component', require('./components/IrrAccessRequestListComponent.vue').default);
Vue.component('irr-publish-request-list-component', require('./components/IrrPublishRequestListComponent.vue').default);
Vue.component('irr-user-list-component', require('./components/IrrUserListComponent.vue').default);
Vue.component('irr-map-component', require('./components/IrrMapComponent.vue').default);

//Revoke consent components
Vue.component('revoke-consent-request-root-component', require('./components/RevokeConsentRequestRootComponent.vue').default);
Vue.component('revoke-consent-request-form-component', require('./components/RevokeConsentRequestFormComponent.vue').default);
Vue.component('revoke-consent-request-list-component', require('./components/RevokeConsentRequestListComponent.vue').default);
Vue.component('revoke-consent-request-data-component', require('./components/RevokeConsentRequestDataComponent.vue').default);


/** Mixins */
Vue.mixin({
  methods: {
    //modify pagination HTML for smaller screens - removes the numbered elements leaving only the next/previous arrows
    //(note: this is dependant on the HTML format used by Laravel - this currently works against Laravel version 7.x)
    modifyPaginationHtml: function() {
      $('.pagination .page-item:not(:first-child):not(:last-child)').addClass('d-none d-md-block');
    },
  },
  mounted: function () {
    this.modifyPaginationHtml();
  }
})

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
